import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

import {
	type ContentAppearanceToAtlaskitMap,
	type FullPageAppearances,
	ContentAppearanceType,
} from './contentAppearanceTypes.ts';

const _contentAppearanceToAtlaskitMap: ContentAppearanceToAtlaskitMap = {
	[ContentAppearanceType.DEFAULT]: 'full-page',
	[ContentAppearanceType.FULL_WIDTH]: 'full-width',
	[ContentAppearanceType.MAX]: 'max',
};

export const getContentAppearanceForAtlaskit: MemoizedFn<
	(contentAppearance: ContentAppearanceType) => FullPageAppearances
> = memoizeOne((contentAppearance: ContentAppearanceType): FullPageAppearances => {
	const appearanceForAtlaskit = _contentAppearanceToAtlaskitMap[contentAppearance];

	if (appearanceForAtlaskit) {
		return appearanceForAtlaskit;
	}
	return getDefaultContentAppearanceForAtlaskit();
});

export const getDefaultContentAppearanceForAtlaskit = (): FullPageAppearances => {
	return _contentAppearanceToAtlaskitMap[ContentAppearanceType.DEFAULT];
};
